import { createContext } from 'react';

const AlertContext = createContext({ openAlert: () => null });

export default AlertContext;
